/* Rose Lane — deferred images.
   An element rendered with data-rl-defer ships its urls in data-src /
   data-srcset (a <video> in data-poster): nothing downloads until it comes
   within 300 px of the viewport. loading="lazy" alone is not enough — Chrome
   fetches anything within 1 250 px (2 500 px on a slow link), i.e. the first
   screens of the home, in competition with the LCP image.
   data-rl-defer="hover" is revealed only on devices with a real pointer: a
   hover image never shows on touch. */
(function () {
  var SELECTOR = '[data-rl-defer]';
  var canHover = window.matchMedia('(hover: hover)').matches;

  function reveal(el) {
    if (!el.hasAttribute('data-rl-defer')) return;
    if (el.getAttribute('data-rl-defer') === 'hover' && !canHover) return;
    var picture = el.parentElement;
    if (picture && picture.tagName === 'PICTURE') {
      picture.querySelectorAll('source[data-srcset]').forEach(function (source) {
        source.setAttribute('srcset', source.getAttribute('data-srcset'));
        source.removeAttribute('data-srcset');
      });
    }
    // srcset before src, so the browser picks a candidate once.
    ['srcset', 'src', 'poster'].forEach(function (name) {
      var value = el.getAttribute('data-' + name);
      if (value === null) return;
      el.setAttribute(name, value);
      el.removeAttribute('data-' + name);
    });
    el.removeAttribute('data-rl-defer');
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(SELECTOR).forEach(reveal);
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      reveal(entry.target);
    });
  }, { rootMargin: '300px 0px' });

  function watch(root) {
    if (root.matches && root.matches(SELECTOR)) observer.observe(root);
    if (root.querySelectorAll) root.querySelectorAll(SELECTOR).forEach(function (el) { observer.observe(el); });
  }
  watch(document);
  // Deferred images only come from theme sections rendered with the page. No
  // document-wide MutationObserver: apps inject hundreds of nodes and watching
  // them cost ~100 ms of main thread on a phone. One more pass at load, the
  // sections the theme editor re-renders, and a hook for theme scripts that
  // inject deferred markup later (window.RLDeferImages.watch(element)).
  window.addEventListener('load', function () { watch(document); }, { once: true });
  document.addEventListener('shopify:section:load', function (event) { watch(event.target); });
  window.RLDeferImages = { watch: watch };
})();
